import { type ReactNode } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ChatbotWidget from "./ChatbotWidget";

interface LayoutProps {
  children: ReactNode;
  user: {
    id: string;
    email: string;
    role: string;
    firstName: string;
    lastName: string;
    profilePictureUrl?: string;
  };
  showChatbot?: boolean;
}

export default function Layout({ children, user, showChatbot = false }: LayoutProps) {
  const isCandidate = user.role === "candidate";
  
  return (
    <div className="min-h-screen bg-gray-50 font-muli">
      <Header user={user} hideNotifications={isCandidate} />
      <div className="flex">
        {!isCandidate && <Sidebar userRole={user.role} />}
        <main className={`${isCandidate ? 'w-full' : 'flex-1'} p-8`} data-testid="main-content">
          {children}
        </main>
      </div>
      {showChatbot && <ChatbotWidget user={user} />}
    </div>
  );
}
